import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const Nav = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s var(--ease);
  background: ${({ $scrolled }) =>
    $scrolled ? 'rgba(255,255,255,0.95)' : 'transparent'};
  backdrop-filter: ${({ $scrolled }) =>
    $scrolled ? 'blur(20px)' : 'none'};
  border-bottom: ${({ $scrolled }) =>
    $scrolled ? '1px solid var(--gray-5)' : '1px solid transparent'};
`;

const Inner = styled.div`
  max-width: var(--max-width);
  width: 100%;
  padding: 0 2.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    padding: 0 1.5rem;
  }
`;

const Logo = styled.a`
  font-weight: 600;
  font-size: 0.95rem;
  color: ${({ $scrolled }) => $scrolled ? 'var(--dark-2)' : 'var(--white)'};
  text-decoration: none;
  cursor: pointer;
  letter-spacing: -0.02em;
  transition: all 0.4s var(--ease);
`;

const Links = styled.div`
  display: flex;
  gap: 2rem;
  align-items: center;

  @media (max-width: 480px) {
    gap: 1.25rem;
  }
`;

const NavLink = styled.a`
  font-size: 0.82rem;
  color: ${({ $scrolled }) => $scrolled ? 'var(--gray-2)' : 'rgba(255,255,255,0.7)'};
  text-decoration: none;
  cursor: pointer;
  transition: all 0.3s var(--ease);
  font-weight: 400;
  letter-spacing: 0.01em;

  &:hover {
    color: ${({ $scrolled }) => $scrolled ? 'var(--dark-2)' : 'var(--white)'};
  }
`;

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <Nav $scrolled={scrolled}>
      <Inner>
        <Logo $scrolled={scrolled} onClick={() => go('hjem')}>
          Andreassen Kapital
        </Logo>
        <Links>
          <NavLink $scrolled={scrolled} onClick={() => go('om')}>Om oss</NavLink>
          <NavLink $scrolled={scrolled} onClick={() => go('kontakt')}>Kontakt</NavLink>
        </Links>
      </Inner>
    </Nav>
  );
};

export default Navbar;
